import React, { Component } from 'react'
import './homepage.css'
import photoHuntData from './checklistdata.ts'

export class Homepage extends Component {
    render() {
        return (
            <div className="homepage-container">
                <header className="homepage-header">
                    <p className="site-subtitle">Creative Scrapbooking Challenges to Inspire Your Next Layout</p>
                </header>

                <main className="homepage-main">
                    <section className="challenges-section">
                        <h2>Challenge Generators</h2>
                        <div className="challenges-grid">
                            <a className="challenge-card" href="./recipe">
                                <h3>Recipe Generator</h3>
                                <p>Get a custom combination of scrapbooking elements to create with</p>
                            </a>
                            <a className="challenge-card" href="./pick5">
                                <h3>Pick 5 Challenge</h3>
                                <p>Choose any 5 items from a list of 10 scrapbooking elements</p>
                            </a>
                            <a className="challenge-card" href="./thisorthat">
                                <h3>This OR That</h3>
                                <p>Make quick decisions between different scrapbooking options</p>
                            </a>
                            <a className="challenge-card" href="./tictactoe">
                                <h3>Tic-Tac-Toe Generator</h3>
                                <p>Complete a line of scrapbooking challenges in a fun grid format</p>
                            </a>
                            <a className="challenge-card" href="./trickytictactoe">
                                <h3>Tricky Tic-Tac-Toe</h3>
                                <p>Advanced tic-tac-toe with specific, challenging scrapbooking elements</p>
                            </a>
                            <a className="challenge-card" href="./colourchallenge">
                                <h3>Colour Challenge</h3>
                                <p>Discover new color combinations for your scrapbook layouts</p>
                            </a>
                            <a className="challenge-card" href="./layout">
                                <h3>Layout Inspiration</h3>
                                <p>Get inspired with layout ideas and design suggestions</p>
                            </a>
                            <a className="challenge-card" href="./photohunt">
                                <h3>{photoHuntData.eventName}</h3>
                                <p>A checklist of photo prompts and scrapbook challenges for the current event on the snapscraprepeat facebook group</p>
                            </a>
                        </div>
                    </section>

                    <section className="info-section">
                        <a className="info-link" href="./about">
                            <h3>About Snap Scrap Repeat</h3>
                            <p>Learn more about our mission to inspire creativity</p>
                        </a>
                    </section>
                </main>
            </div>
        )
    }
}

export default Homepage
